import type { LocationPermissionResponse } from 'expo-location';
import { Platform } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export function getLocationGrantType(permissionResponse: LocationPermissionResponse) {
  if (Platform.OS === 'ios' && typeof permissionResponse.expires === 'number') {
    return 'allow_once';
  }

  return 'while_using';
}
